import React from 'react';
import Footer from '../containers/Footer/Footer';
import Contact from '../containers/Contact/Contact';
import Oftaial from '../containers/Idroflog/Oftaial';
import OftaialAccordion from '../components/OftaialAccordion';

const OftaialPage = () => {
  return (
    <>
      <div className="product-page">
        <Oftaial />
        <OftaialAccordion />
      </div>
      <Contact />
      <Footer />
    </>
  );
};

export default OftaialPage;
